import { render, staticRenderFns } from "./OrgDetail.vue?vue&type=template&id=00aa5dc2&scoped=true&"
import script from "./OrgDetail.vue?vue&type=script&lang=js&"
export * from "./OrgDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrgDetail.vue?vue&type=style&index=0&id=00aa5dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aa5dc2",
  null
  
)

export default component.exports